import { createReducer } from '../utils/reducers';
import { NOTIF_SUBSCRIBE_FAIL, NOTIF_SUBSCRIBE_SUCCESS } from '../constants';

const INITIAL_STATE = {
    isPaymentFailed: false,
    isPaymentSuccessfull: false,
};

export default createReducer(INITIAL_STATE, {
    [NOTIF_SUBSCRIBE_FAIL]: state => {
        return {
            ...state,
            isPaymentFailed: true,
        };
    },
    [NOTIF_SUBSCRIBE_SUCCESS]: state => {
        return {
            ...state,
            isPaymentFailed: false,
            isPaymentSuccessfull: true,
        };
    },
});



// WEBPACK FOOTER //
// ./src/reducers/notifications.js